import React, { RefObject } from 'react';
import styles from '../SplitScrollTable.module.scss';

interface BottomScrollbarProps {
  bottomScrollbarRef: RefObject<HTMLDivElement>;
  onScroll: () => void;
  contentWidth?: number;
}

export const BottomScrollbar: React.FC<BottomScrollbarProps> = ({
  bottomScrollbarRef,
  onScroll,
  contentWidth
}) => {
  return (
    <div
      className={styles.bottomScrollbarContainer}
      ref={bottomScrollbarRef}
      onScroll={onScroll}
    >
      <div
        className={styles.bottomScrollbarContent}
        style={contentWidth ? { minWidth: contentWidth } : undefined}
      />
    </div>
  );
};
